// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3956":"c54637d7f5ad6651","4980":"26af15f48cd70189","6554":"fffa72df1775de66"}[chunkId] + ".js";
};